export const MAIN_BLOCK_MAX_WIDTH = "900px";
